export default __webpack_public_path__ + "static/media/Cher_Gopman_2_AHV_In_Moms_We_Trust.cdc02936.jpg";